import { render, staticRenderFns } from "./FmuCourses.vue?vue&type=template&id=22868cae&scoped=true&"
import script from "./FmuCourses.vue?vue&type=script&lang=js&"
export * from "./FmuCourses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22868cae",
  null
  
)

export default component.exports